
import { RateAiResponseType, RateAiResponseKind, SystemEvent } from '@/common/bot/enum';
import { AiMessageForUser, RateAiResponseEvent } from '@/common/bot/types';
import LikeIcon from '@/components/icons/LikeIcon.vue';
import FilledLikeIcon from '@/components/icons/FilledLikeIcon.vue';
import DislikeIcon from '@/components/icons/DislikeIcon.vue';
import FilledDislikeIcon from '@/components/icons/FilledDislikeIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import snarkdown from 'snarkdown';
import insane from 'insane';
import * as env from '@/common/environment';
import { removeMessagePrefix } from '@/common/bot/flow-frameworks/messages';

@Component({
  components: {
    LikeIcon,
    FilledLikeIcon,
    DislikeIcon,
    FilledDislikeIcon,
  },
})
export default class AiResponseForUserMessage extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: AiMessageForUser;

  readonly RateAiResponseType = RateAiResponseType;

  selectedRate: RateAiResponseKind | null = null;

  created () {
    this.selectedRate = localStorage.getItem('selectedAiRate-' + this.message.id) as RateAiResponseKind | null;
  }

  get messageText () {
    return removeMessagePrefix(this.message.message);
  }

  get showActionButtons () {
    const { rateResponse } = env.get('AI') || { rateResponse: false };
    return rateResponse;
  }

  get parsedMessage () {
    return insane(snarkdown(this.messageText));
  }

  get isLikeSelected () {
    return this.selectedRate === RateAiResponseType.LIKE;
  }

  get isDislikeSelected () {
    return this.selectedRate === RateAiResponseType.DISLIKE;
  }

  buildEvent (selected: RateAiResponseKind) {
    const event: RateAiResponseEvent = {
      type: SystemEvent.RATE_AI_RESPONSE,
      message: this.message,
      payload: { selected },
    };

    this.selectedRate = selected;
    localStorage.setItem('selectedAiRate-' + this.message.id, selected);

    this.$emit('send:event', event);
  }
}
